module.exports = __webpack_public_path__ + "img/logo-footer.c68f9cb6.png";